import React from 'react';
import Item from './Item'

class List extends React.Component {
	render() {
		if (!this.props.list)
			return null;

		const items = this.props.list.items.map((e, i) => {
			return (
				<Item key={i} item={e} />)
		});

		return (
			<React.Fragment>
				{items}
			</React.Fragment>
		)
	}
}

export default List;



// WEBPACK FOOTER //
// ./src/areas/admin/console/logs/List.js